webpackJsonp([118],{

/***/ 1957:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

function selectedAnswer(id) {
	this.$emit('selected-icon', id, this.question.questionId);
}

function currentTemplate() {
	var _ref = this.question.answer ? this.question.answer.typeAnswer : null,
	    id = _ref.id;

	var opt = {
		1: 'facesTemplate',
		2: 'radioButtonTemplate',
		3: 'checkButtonTemplate',
		4: 'facesTextTemplate'
	};
	return opt[id];
}
/* harmony default export */ __webpack_exports__["a"] = ({
	name: 'questions-component',
	components: {
		radioButtonTemplate: function radioButtonTemplate() {
			return __webpack_require__.e/* import() */(122).then(__webpack_require__.bind(null, 2513));
		},
		checkButtonTemplate: function checkButtonTemplate() {
			return __webpack_require__.e/* import() */(123).then(__webpack_require__.bind(null, 2515));
		},
		facesTextTemplate: function facesTextTemplate() {
			return __webpack_require__.e/* import() */(120).then(__webpack_require__.bind(null, 2517));
		},
		facesTemplate: function facesTemplate() {
			return __webpack_require__.e/* import() */(121).then(__webpack_require__.bind(null, 2521));
		}
	},
	computed: {
		currentTemplate: currentTemplate
	},
	methods: {
		selectedAnswer: selectedAnswer
	},
	props: {
		order: Number,
		question: {
			default: function _default() {},
			type: Object
		}
	}
});

/***/ }),

/***/ 2510:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_question_component_vue__ = __webpack_require__(1957);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07b8e807_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_question_component_vue__ = __webpack_require__(2525);
function injectStyle (ssrContext) {
  __webpack_require__(2511)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-07b8e807"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_question_component_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_07b8e807_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_question_component_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2511:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2512);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1266)("362ff9e6", content, true, {});

/***/ }),

/***/ 2512:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1265)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Lato_regular;src:url(\"/static/fonts/Lato-Regular.ttf\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroT;src:url(\"/static/fonts/NeuzeitGroT.eot\");src:url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBold;src:url(\"/static/fonts/NeuzeitGroTBold.eot\");src:url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTLig;src:url(\"/static/fonts/NeuzeitGroLig.eot\");src:url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");font-weight:400;font-style:normal}@font-face{font-family:NeuzeitGroTBla;src:url(\"/static/fonts/NeuzeitGroTBla.eot\");src:url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"),url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");font-weight:400;font-style:normal}.question-container[data-v-07b8e807]{display:grid;grid-column-gap:10px;grid-row-gap:15px;grid-template-columns:.5fr 4fr;grid-template-rows:repeat(auto-fit,minmax(40px,1fr));padding-top:45px}@media (max-width:768px){.question-container[data-v-07b8e807]{grid-template-columns:1fr;grid-template-rows:auto;padding-top:35px}}.question-number[data-v-07b8e807]{-webkit-box-align:center;-ms-flex-align:center;align-items:center;border-radius:50%;display:-webkit-box;display:-ms-flexbox;display:flex;font-family:NeuzeitGroTBold;font-size:20px;grid-column:1;grid-row:1/span 2;height:28px;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;margin:0 0 0 auto;width:28px}@media (max-width:768px){.question-number[data-v-07b8e807]{grid-row:1;margin:0 auto}}.question-text[data-v-07b8e807]{font-family:NeuzeitGroTBold;margin:0 auto;max-width:100%;padding:0 20px;text-align:center}@media (max-width:500px){.question-text[data-v-07b8e807]{font-size:16px;line-height:normal;font-family:Times New Roman,Times,serif}}", "", {"version":3,"sources":["/opt/build/repo/src/components/polls/question-component.vue"],"names":[],"mappings":"AACA,WACE,yBAA4B,AAC5B,0CAA2C,AAC3C,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,wBAA2B,AAC3B,yCAA0C,AAC1C,iHAAmH,AACnH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,4BAA+B,AAC/B,6CAA8C,AAC9C,yHAA2H,AAC3H,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,2CAA4C,AAC5C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,WACE,2BAA8B,AAC9B,4CAA6C,AAC7C,uHAAyH,AACzH,gBAAoB,AACpB,iBAAmB,CACpB,AACD,qCACE,aAAc,AACd,qBAAsB,AACtB,kBAAmB,AACnB,+BAAiC,AACjC,qDAAwD,AACxD,gBAAkB,CACnB,AACD,yBACA,qCACM,0BAA2B,AAC3B,wBAAyB,AACzB,gBAAkB,CACvB,CACA,AACD,kCACE,yBAA0B,AACtB,sBAAuB,AACnB,mBAAoB,AAC5B,kBAAmB,AACnB,oBAAqB,AACrB,oBAAqB,AACrB,aAAc,AACd,4BAA+B,AAC/B,eAAgB,AAChB,cAAe,AACf,kBAAqB,AACrB,YAAa,AACb,wBAAyB,AACrB,qBAAsB,AAClB,uBAAwB,AAChC,kBAAmB,AACnB,UAAY,CACb,AACD,yBACA,kCACM,WAAY,AACZ,aAAe,CACpB,CACA,AACD,gCACE,4BAA+B,AAC/B,cAAe,AACf,eAAgB,AAChB,eAAgB,AAChB,iBAAmB,CACpB,AACD,yBACA,gCACM,eAAgB,AAChB,mBAAoB,AACpB,uCAA6C,CAClD,CACA","file":"question-component.vue","sourcesContent":["\n@font-face {\n  font-family: 'Lato_regular';\n  src: url(\"/static/fonts/Lato-Regular.ttf\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroT';\n  src: url(\"/static/fonts/NeuzeitGroT.eot\");\n  src: url(\"/static/fonts/NeuzeitGroT.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroT.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBold';\n  src: url(\"/static/fonts/NeuzeitGroTBold.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBold.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBold.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTLig';\n  src: url(\"/static/fonts/NeuzeitGroLig.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTLig.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTLig.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n@font-face {\n  font-family: 'NeuzeitGroTBla';\n  src: url(\"/static/fonts/NeuzeitGroTBla.eot\");\n  src: url(\"/static/fonts/NeuzeitGroTBla.ttf\") format(\"truetype\"), url(\"/static/fonts/NeuzeitGroTBla.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n}\n.question-container[data-v-07b8e807] {\n  display: grid;\n  grid-column-gap: 10px;\n  grid-row-gap: 15px;\n  grid-template-columns: 0.5fr 4fr;\n  grid-template-rows: repeat(auto-fit, minmax(40px, 1fr));\n  padding-top: 45px;\n}\n@media (max-width: 768px) {\n.question-container[data-v-07b8e807] {\n      grid-template-columns: 1fr;\n      grid-template-rows: auto;\n      padding-top: 35px;\n}\n}\n.question-number[data-v-07b8e807] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  border-radius: 50%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-family: \"NeuzeitGroTBold\";\n  font-size: 20px;\n  grid-column: 1;\n  grid-row: 1 / span 2;\n  height: 28px;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  margin: 0 0 0 auto;\n  width: 28px;\n}\n@media (max-width: 768px) {\n.question-number[data-v-07b8e807] {\n      grid-row: 1;\n      margin: 0 auto;\n}\n}\n.question-text[data-v-07b8e807] {\n  font-family: \"NeuzeitGroTBold\";\n  margin: 0 auto;\n  max-width: 100%;\n  padding: 0 20px;\n  text-align: center;\n}\n@media (max-width: 500px) {\n.question-text[data-v-07b8e807] {\n      font-size: 16px;\n      line-height: normal;\n      font-family: \"Times New Roman\", Times, serif;\n}\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 2525:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-container"},[_c('span',{staticClass:"question-number",style:(("background-color:" + (_vm.$appColors.primary) + ";color:" + (_vm.$appColors.white)))},[_vm._v(_vm._s(_vm.order))]),_vm._v(" "),_c('p',{staticClass:"question-text",style:(("color:" + (_vm.$appColors.secondary)))},[_vm._v(_vm._s(_vm.question.question.name))]),_vm._v(" "),_c(_vm.currentTemplate,{tag:"component",attrs:{"question-id":_vm.question.id,"answers":_vm.question.answer.details},on:{"selected-icon":_vm.selectedAnswer}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/118.e78fb16a35b11a61fb87.js